import { getCookie, createCookie, cookies } from '../cookies';

// format of english and french lang for cookie setup
const frCMSPreferredCulture = 'fr-CA';
const enCMSPreferredCulture = 'en-CA';

export function getUserPreferredLang() {
  const preferredLang = getCookie(cookies.CMSPreferredCulture);
  if (preferredLang === frCMSPreferredCulture) {
    return 'fr_CA';
  }
  if (preferredLang === enCMSPreferredCulture) {
    return 'en_CA';
  }
  return 'en_CA';
}

export function setUserPreferredLang(lang) {
  if (lang === 'fr_CA') {
    createCookie(cookies.CMSPreferredCulture, frCMSPreferredCulture, false, true);
    document.documentElement.setAttribute("lang", 'fr');
  } else if (lang === 'en_CA') {
    createCookie(cookies.CMSPreferredCulture, enCMSPreferredCulture, false, true);
    document.documentElement.setAttribute("lang", 'en');
  }
}
